
define('known/collections/leagueUserCollection',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueUserModel'
], function($, _, Backbone, LeagueUserModel){
	var LeagueUserCollection = Backbone.Collection.extend({
		model : LeagueUserModel,
		leagueId : null, //Populate this on construction
		//leagueInstanceId : null, //Populate this on construction
	
		url: function() {
			return '/draftapp/leagues/' + this.leagueId + '/league-instances/' + this.leagueInstanceId.get('id') + '/league-users';
		},
		
		initialize: function(models, options) {
			this.leagueId = options.leagueId;
			//this.leagueInstanceId = options.leagueInstanceId;
	    }
	});
	
	return LeagueUserCollection;  
});